import React from 'react';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import {numberToFraction} from '../../utils/gameUtils';
import { useMediaQuery } from '@material-ui/core';
import { TwoValue } from '../TwoValue';

const styles = makeStyles(theme => ({
    container: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        [theme.breakpoints.down(600)]: {
            justifyContent: 'flex-start',
        },
    },
    valueContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        height: 37,
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '150%',
        letterSpacing: '0.3px',
        color: '#ADB1B7',
        [theme.breakpoints.up(600)]: {
            margin: 4,
            height: 32,
        },
    },
}))

export function OddsOpenerValue({game, marketFilter}) {
    const classes = styles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

    const formatOdds = (line, outcome, isHome) => {
        let total = outcome['total'];
        if (!isHome) {
            total = 'o' + total;
        } else {
            total = 'u' + total;
        }
        switch (marketFilter) {
            case 'spread':
                return <TwoValue firstValue={line['spread']} secondValue={outcome['odds']} type="spread" isHome={isHome} />;
            case 'puck_line':
                return <TwoValue firstValue={line['spread']} secondValue={outcome['odds']} type="spread" isHome={isHome} />;
            case 'run_line':
                return <TwoValue firstValue={line['spread']} secondValue={outcome['odds']} type="spread" isHome={isHome} />;
            case '2way':
                return <TwoValue secondValue={outcome['odds']}/>;
            case 'total':
                return <TwoValue firstValue={total} secondValue={outcome['odds']}/>;
            default:
                return <TwoValue firstValue={line['spread']} secondValue={outcome['odds']} type="spread" isHome={isHome} />;
        }
    }

    const consensus = game['consensus'] || {}

    if (!consensus)
        return null;

    const lines = consensus['lines'];
    if (!lines)
        return null;

    const lineName = `${marketFilter === '2way' ? 'moneyline' : marketFilter}_open`;
    const currentLine = lines.find((line) => line.name === lineName);

    if (!currentLine)
        return null;

    const [homeOutcome, awayOutcome] = currentLine['outcomes'];

    return (
        <div className={classes.container}>
            <div className={`${classes.valueContainer}`} style={{margin: isMobile ? '9px 0 8px' : ''}}>
                {formatOdds(currentLine, awayOutcome, false)}
            </div>
            <div className={`${classes.valueContainer}`}>
                {formatOdds(currentLine, homeOutcome, true)}
            </div>
        </div>
    )
}